var map = {
	"./krecove-zily_1_after_tn.jpg": 1493,
	"./krecove-zily_1_before_tn.jpg": 1494,
	"./krecove-zily_2_after_tn.jpg": 1495,
	"./krecove-zily_2_before_tn.jpg": 1496,
	"./krecove-zily_3_after_tn.jpg": 1497,
	"./krecove-zily_3_before_tn.jpg": 1498,
	"./krecove-zily_4_after_tn.jpg": 1499,
	"./krecove-zily_4_before_tn.jpg": 1500,
	"./krecove-zily_5_after_tn.jpg": 1501,
	"./krecove-zily_5_before_tn.jpg": 1502,
	"./krecove-zily_6_after_tn.jpg": 1503,
	"./krecove-zily_6_before_tn.jpg": 1504,
	"./zarustajici-nehty_1_after_tn.jpg": 1505,
	"./zarustajici-nehty_1_before_tn.jpg": 1506,
	"./zarustajici-nehty_2_after_tn.jpg": 1507,
	"./zarustajici-nehty_2_before_tn.jpg": 1508,
	"./zarustajici-nehty_3_after_tn.jpg": 1509,
	"./zarustajici-nehty_3_before_tn.jpg": 1510,
	"./zarustajici-nehty_4_after_tn.jpg": 1511,
	"./zarustajici-nehty_4_before_tn.jpg": 1512,
	"./zarustajici-nehty_5_after_tn.jpg": 1513,
	"./zarustajici-nehty_5_before_tn.jpg": 1514
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2180;



//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/obecna-a-zilni-chirurgie nonrecursive \.(png|jpe?g|svg)$
// module id = 2180
// module chunks = 0